import React, { useState } from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
} from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

ChartJS.register(ArcElement, Tooltip, Legend);

const plugin = {
  beforeInit(chart) {
    // Get reference to the original fit function
    const originalFit = chart.legend.fit;

    // Override the fit function
    chart.legend.fit = function fit() {
      // Call original function and bind scope in order to use `this` correctly inside it
      originalFit.bind(chart.legend)();
      // Change the height as suggested in another answers
      this.height = this.height + 25;
      this.width += 120;
    };
  },
};

export const options = {
  responsive: true,
  scales: {
    x: {
      ticks: {
        color: '#000',
        size: 15,
      },
    },
    y: {
      border: {
        display: false,
      },
    },
  },
  plugins: {
    legend: {
      position: 'top',
      labels: {
        padding: 15,
        usePointStyle: true,
        pointStyle: 'rect',
        color: '#707070',
        font: {
          weight: 'bold',
        },
      },
      align: 'start',
    },
  },
};



const ClaimsWidget = ({months,pharmacies,ces}) => {

  const data = {
    labels: months,
    datasets: [
      {
        label: 'Pharmacies',
        data: pharmacies,
        borderColor: '#12545E',
        backgroundColor: '#12545E',
        pointRadius: 2.5
      },
      {
        label: 'Covered Entities',
        data: ces,
        borderColor: '#B54DA0',
        backgroundColor: '#B54DA0',
        pointRadius: 2.5
      },
    ],
  };


  return (
    <ErrorBoundary>
      <Card className='p-3 h-100'>
        <CardHeader className='border-0 bg-white px-0 pt-0'>
          <Row className='align-items-center'>
            <Col>
              <CardTitle className="f-20 font-weight-500">
                Contracts
              </CardTitle>
            </Col>
            <Col xs='auto'>
              <Nav className='widget-tabs'>
               
              </Nav>
            </Col>
          </Row>
        </CardHeader>
        <CardBody className='dashboard-chart-body'>
          <Line options={options} data={data} plugins={[plugin]} />
          {/* <div className="view-report">
            <a
              href="data:text/csv;charset=utf-8,'Top Performing TPAs 			
              TPA Name	Captured Rx Count	Value	
              PharmaForce	3,547	$215,124 	
              Verity	2804	$101,225 	
              340Basics	2500	$85,223 	
              SunRx	1500	$62,354 '"
              download="pharmaForce.csv"
            >
              {" "}
              View Report{" "}
            </a>
          </div> */}
        </CardBody>
      </Card>
    </ErrorBoundary>
  );
};

export default ClaimsWidget;
